import vue from 'vue';
import vm from '@/main';

import messageContent from '../components/messageContent/index.vue';
import { MessageBox } from 'element-ui';

vue.component('messageContent', messageContent);

export function dailyNotify(options) {
  const { onKnow, commit, title, msgType, messageTime, messageDataList } = options;
  console.log('## vm', vm);
  const h = vm.$createElement;
  // const textArr = formatMessage(text);
  vue.prototype.$myMessageBox = MessageBox;
  return MessageBox({
    customClass: 'daily-notify-message',
    title: title || '提醒消息',
    iconClass: 'el-icon-message-solid notify-icon',
    message: h('message-content', {
      class: 'notify-content',
      style: 'width: 100%;',
      props: {
        msgType,
        messageTime,
        messageDataList,
        commit,
        onKnow
      }
    }),
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: '我知道了',
    closeOnClickModal: false,
    showClose: false,
    //
    beforeClose: async (action, instance, done) => {
      if (action === 'cancel') {
        if (onKnow) onKnow();
        done();
      }
    }
  });
}

export function supervisionMessageAlert(messageInfo, setHasUnRead, callback) {
  const { id, msgTitle, msgContent, msgType, messageTime, messageDataList } = messageInfo;
  return dailyNotify({
    title: msgTitle,
    msgType,
    messageTime,
    messageDataList: messageDataList,
    text: msgContent,
    setHasUnRead,
    onKnow: async () => {
      await Fetch.pushedMessage({ id });
      await Fetch.readSupervisionMessage({ messageIds: [id] });
      // 清除实例
      await setHasUnRead();
      callback && callback();
    }
  });
}
